import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getCategoriesAndTags } from '@services/public.service';

export const PUBLIC_TAGS_QUERY_KEY = ['public', 'categories-and-tags'];

export function usePublicTags(params = {}) {
    const { enabled = true } = params;
    const q = useQuery({
        queryKey: PUBLIC_TAGS_QUERY_KEY,
        queryFn: () => getCategoriesAndTags(),
        enabled: !!enabled,
        staleTime: 5 * 60 * 1000,
    });

    const tags = useMemo(() => {
        const data = q.data?.tags ?? q.data?.data?.tags ?? [];
        if (!Array.isArray(data)) return [];
        return data
            .map((t) => ({
                id: t?.id ?? t?.tag,
                tag: String(t?.tag ?? '').trim(),
            }))
            .filter((t) => t.tag.startsWith('#'));
    }, [q.data]);

    return { ...q, tags };
}

